/**
 * MODULE: _shared/frontend-shell/src/layout/shellRouteContentKey.ts
 * PURPOSE: Top-level shell module key for route transition overlays (#109)
 * DEPENDENCIES: none
 * PUBLIC_API: shellRouteContentKey
 * SIDE_EFFECTS: none
 * AGENT_SAFETY: SAFE
 * RECENT: 2026-05-22 [2.2.1132] — remount key for AppLayout content on module switch. [2.2.1132]
 */

/** Remount / transition page content when switching top-level modules (home → messaging, etc.). */
export function shellRouteContentKey(pathname: string): string {
  const segment = pathname.split('/').filter(Boolean)[0];
  return segment ?? 'home';
}
